import { rentalImages, homestayImages, apartmentImages } from './propertyImages';

export interface Property {
  id: number;
  title: string;
  area: string;
  price: number;
  priceUnit: string;
  bedrooms: number;
  bathrooms: number;
  size: number;
  type: 'rental' | 'homestay' | 'apartment';
  image: string;
  images: string[];
  address: string;
  description: string;
  amenities: string[];
  featured: boolean;
}

export const areas = [
  'Tất cả khu vực',
  'Phường 1 - Trung tâm',
  'Phường 2',
  'Phường 3',
  'Phường 4',
  'Phường 5',
  'Phường 6',
  'Phường 7',
  'Phường 8',
  'Phường 9',
  'Phường 10',
  'Phường 11',
  'Phường 12',
  'Xuân Thọ',
  'Tà Nung',
  'Lạc Dương',
  'Nam Ban',
];

export const rentalListings: Property[] = [
  {
    id: 1,
    title: 'Nhà vườn nguyên căn view thung lũng',
    area: 'Phường 3',
    price: 12000000,
    priceUnit: '/tháng',
    bedrooms: 3,
    bathrooms: 2,
    size: 120,
    type: 'rental',
    image: rentalImages[1].main,
    images: rentalImages[1].gallery,
    address: '15 Nguyễn Thị Minh Khai, Phường 3, Đà Lạt',
    description: 'Ngôi nhà vườn nguyên căn tuyệt đẹp với view thung lũng thoáng đãng, sân vườn trồng hoa đầy màu sắc, không gian yên tĩnh và trong lành.',
    amenities: ['Sân vườn', 'Chỗ đậu xe', 'WiFi', 'Máy giặt', 'Tủ lạnh', 'Bếp đầy đủ'],
    featured: true,
  },
  {
    id: 2,
    title: 'Biệt thự Pháp cổ nguyên căn trung tâm',
    area: 'Phường 1 - Trung tâm',
    price: 25000000,
    priceUnit: '/tháng',
    bedrooms: 4,
    bathrooms: 3,
    size: 220,
    type: 'rental',
    image: rentalImages[2].main,
    images: rentalImages[2].gallery,
    address: '8 Trần Hưng Đạo, Phường 1, Đà Lạt',
    description: 'Biệt thự Pháp cổ được bảo tồn nguyên vẹn, không gian rộng rãi 4 phòng ngủ, sân vườn rộng 500m², tọa lạc ngay trung tâm thành phố.',
    amenities: ['Sân vườn lớn', 'Gara xe', 'Bể bơi nhỏ', 'WiFi tốc độ cao', 'Máy sưởi', 'Lò sưởi'],
    featured: true,
  },
  {
    id: 3,
    title: 'Nhà phố 3 tầng khu dân cư yên tĩnh',
    area: 'Phường 8',
    price: 8500000,
    priceUnit: '/tháng',
    bedrooms: 3,
    bathrooms: 2,
    size: 90,
    type: 'rental',
    image: rentalImages[3].main,
    images: rentalImages[3].gallery,
    address: '32 Hoàng Diệu, Phường 8, Đà Lạt',
    description: 'Nhà phố 3 tầng khang trang, khu dân cư văn minh, gần chợ Đà Lạt, tiện ích đầy đủ cho gia đình.',
    amenities: ['Chỗ đậu xe', 'WiFi', 'Máy giặt', 'Tủ lạnh', 'Bếp đầy đủ', 'Sân thượng'],
    featured: false,
  },
  {
    id: 4,
    title: 'Căn nhà gỗ view đồi thông Phường 12',
    area: 'Phường 12',
    price: 9000000,
    priceUnit: '/tháng',
    bedrooms: 2,
    bathrooms: 1,
    size: 75,
    type: 'rental',
    image: rentalImages[4].main,
    images: rentalImages[4].gallery,
    address: '67 Hoàng Văn Thụ, Phường 12, Đà Lạt',
    description: 'Căn nhà gỗ ấm cúng bao quanh bởi rừng thông xanh mát, không khí trong lành, thích hợp cho gia đình nhỏ muốn sống gần thiên nhiên.',
    amenities: ['Sân vườn', 'Lò sưởi', 'WiFi', 'Bếp', 'View rừng thông'],
    featured: true,
  },
  {
    id: 5,
    title: 'Nhà mái ngói 2 tầng gần Hồ Xuân Hương',
    area: 'Phường 2',
    price: 15000000,
    priceUnit: '/tháng',
    bedrooms: 3,
    bathrooms: 2,
    size: 130,
    type: 'rental',
    image: rentalImages[5].main,
    images: rentalImages[5].gallery,
    address: '21 Trần Quốc Toản, Phường 2, Đà Lạt',
    description: 'Nhà mái ngói truyền thống 2 tầng, cách Hồ Xuân Hương chỉ 5 phút đi bộ, sân vườn trồng hoa đầy màu sắc.',
    amenities: ['Sân vườn hoa', 'Chỗ đậu xe', 'WiFi', 'Máy giặt', 'View hồ', 'Máy sưởi'],
    featured: false,
  },
  {
    id: 6,
    title: 'Nhà vườn rộng khu ngoại ô Xuân Thọ',
    area: 'Xuân Thọ',
    price: 6000000,
    priceUnit: '/tháng',
    bedrooms: 3,
    bathrooms: 2,
    size: 180,
    type: 'rental',
    image: rentalImages[6].main,
    images: rentalImages[6].gallery,
    address: '55 Đường Xuân Thọ, Xuân Thọ, Đà Lạt',
    description: 'Nhà vườn rộng 500m², khu Xuân Thọ thanh bình, có vườn rau sạch và vườn dâu tây. Không khí trong lành, yên tĩnh.',
    amenities: ['Vườn rau', 'Vườn dâu tây', 'WiFi', 'Bếp lớn', 'Gara', 'Giếng nước'],
    featured: false,
  },
  {
    id: 7,
    title: 'Nhà phố hiện đại view đồi cà phê Phường 11',
    area: 'Phường 11',
    price: 11000000,
    priceUnit: '/tháng',
    bedrooms: 3,
    bathrooms: 2,
    size: 110,
    type: 'rental',
    image: rentalImages[7].main,
    images: rentalImages[7].gallery,
    address: '14 Ngô Quyền, Phường 11, Đà Lạt',
    description: 'Nhà phố hiện đại thiết kế thông minh, view đồi cà phê xanh mát, nội thất cao cấp phong cách Scandinavian, ánh sáng tự nhiên tràn ngập.',
    amenities: ['Sân thượng', 'WiFi tốc độ cao', 'Máy giặt', 'Bếp đầy đủ', 'Chỗ đậu xe', 'Máy sưởi'],
    featured: true,
  },
  {
    id: 8,
    title: 'Biệt thự nhỏ vườn hoa khu Phường 4',
    area: 'Phường 4',
    price: 18000000,
    priceUnit: '/tháng',
    bedrooms: 4,
    bathrooms: 3,
    size: 160,
    type: 'rental',
    image: rentalImages[8].main,
    images: rentalImages[8].gallery,
    address: '7 Trần Nhân Tông, Phường 4, Đà Lạt',
    description: 'Biệt thự nhỏ xinh bao quanh bởi khu vườn hoa đẹp như tranh, 4 phòng ngủ rộng rãi, phong cách Pháp cổ điển, không gian thơ mộng.',
    amenities: ['Vườn hoa', 'Lò sưởi', 'WiFi', 'Bếp đầy đủ', 'Máy giặt', 'Gara xe'],
    featured: true,
  },
  {
    id: 9,
    title: 'Nhà gỗ thông lấy sáng view thung lũng Lạc Dương',
    area: 'Lạc Dương',
    price: 7500000,
    priceUnit: '/tháng',
    bedrooms: 2,
    bathrooms: 1,
    size: 85,
    type: 'rental',
    image: rentalImages[9].main,
    images: rentalImages[9].gallery,
    address: '23 Đường Khe Sanh, Lạc Dương, Đà Lạt',
    description: 'Ngôi nhà gỗ đặc biệt trên sườn đồi Lạc Dương, toàn bộ cửa sổ lấy sáng hướng thung lũng, không gian riêng tư tuyệt đối giữa thiên nhiên hoang dã.',
    amenities: ['View thung lũng', 'Lò sưởi', 'WiFi', 'Bếp', 'Sân thượng', 'Hầm chứa đồ'],
    featured: false,
  },
];

export const homestayListings: Property[] = [
  {
    id: 101,
    title: 'Đà Lạt Dreamy House - View Thung Lũng',
    area: 'Phường 3',
    price: 1500000,
    priceUnit: '/đêm',
    bedrooms: 4,
    bathrooms: 3,
    size: 200,
    type: 'homestay',
    image: homestayImages[101].main,
    images: homestayImages[101].gallery,
    address: '12 Mimosa, Phường 3, Đà Lạt',
    description: 'Homestay lãng mạn với view thung lũng tuyệt đẹp, trang trí theo phong cách Bohemian, sân vườn ngập tràn hoa mimosa vàng rực rỡ.',
    amenities: ['WiFi tốc độ cao', 'Bếp đầy đủ', 'Sân vườn', 'BBQ', 'Máy sưởi', 'Loa bluetooth'],
    featured: true,
  },
  {
    id: 102,
    title: 'Pine Hill Retreat - Nhà trong rừng thông',
    area: 'Phường 12',
    price: 1200000,
    priceUnit: '/đêm',
    bedrooms: 3,
    bathrooms: 2,
    size: 150,
    type: 'homestay',
    image: homestayImages[102].main,
    images: homestayImages[102].gallery,
    address: '89 Rừng Thông, Phường 12, Đà Lạt',
    description: 'Nhà nghỉ dưỡng giữa rừng thông nguyên sinh, không gian riêng tư tuyệt đối, lò sưởi ấm áp, trải nghiệm thiên nhiên độc đáo.',
    amenities: ['Lò sưởi', 'WiFi', 'Bếp', 'Hồ bơi nhỏ', 'Yoga deck', 'BBQ'],
    featured: true,
  },
  {
    id: 103,
    title: 'Đà Lạt Rose Cottage - Nhà hoa hồng',
    area: 'Phường 5',
    price: 900000,
    priceUnit: '/đêm',
    bedrooms: 2,
    bathrooms: 1,
    size: 80,
    type: 'homestay',
    image: homestayImages[103].main,
    images: homestayImages[103].gallery,
    address: '34 Nguyên Tử Lực, Phường 5, Đà Lạt',
    description: 'Căn nhà nhỏ lãng mạn bao quanh bởi vườn hoa hồng 200 gốc, phong cách cottage Anh, thích hợp cho cặp đôi.',
    amenities: ['Vườn hoa hồng', 'WiFi', 'Bếp mini', 'Máy sưởi', 'Xe đạp miễn phí'],
    featured: true,
  },
  {
    id: 104,
    title: 'Lakeside Cabin - View Hồ Xuân Hương',
    area: 'Phường 2',
    price: 2000000,
    priceUnit: '/đêm',
    bedrooms: 3,
    bathrooms: 2,
    size: 120,
    type: 'homestay',
    image: homestayImages[104].main,
    images: homestayImages[104].gallery,
    address: '5 Trần Quốc Toản, Phường 2, Đà Lạt',
    description: 'Cabin sang trọng view Hồ Xuân Hương, cửa sổ kính toàn cảnh nhìn ra mặt hồ bình yên, buổi sáng ngắm sương khói lãng mạn.',
    amenities: ['View hồ', 'WiFi', 'Bồn tắm Jacuzzi', 'Bếp đầy đủ', 'Máy sưởi', 'Balcony'],
    featured: false,
  },
  {
    id: 105,
    title: 'Strawberry Farm Stay - Trải nghiệm nông trại',
    area: 'Xuân Thọ',
    price: 750000,
    priceUnit: '/đêm',
    bedrooms: 2,
    bathrooms: 1,
    size: 60,
    type: 'homestay',
    image: homestayImages[105].main,
    images: homestayImages[105].gallery,
    address: '120 Đường Xuân Thọ, Xuân Thọ, Đà Lạt',
    description: 'Trải nghiệm sống trên nông trại dâu tây thực thụ, tự hái dâu, nấu mứt, thưởng thức ẩm thực địa phương trong không gian xanh mát.',
    amenities: ['Nông trại dâu tây', 'Bếp', 'WiFi', 'Hướng dẫn nấu ăn', 'Xe đạp'],
    featured: false,
  },
  {
    id: 106,
    title: 'Fog & Forest Lodge - Lạc Dương Hills',
    area: 'Lạc Dương',
    price: 1800000,
    priceUnit: '/đêm',
    bedrooms: 5,
    bathrooms: 3,
    size: 250,
    type: 'homestay',
    image: homestayImages[106].main,
    images: homestayImages[106].gallery,
    address: '8 Đường Lạc Dương, Lạc Dương, Đà Lạt',
    description: 'Lodge cao cấp trên đồi Lạc Dương, view toàn cảnh núi rừng hùng vĩ, thích hợp cho nhóm bạn và gia đình lớn.',
    amenities: ['View núi', 'Lò sưởi', 'BBQ', 'WiFi', 'Bếp lớn', 'Phòng chơi', 'Sân thượng'],
    featured: true,
  },
  {
    id: 107,
    title: 'Lavender Dream - Nhà thơ mộng Phường 6',
    area: 'Phường 6',
    price: 1100000,
    priceUnit: '/đêm',
    bedrooms: 3,
    bathrooms: 2,
    size: 110,
    type: 'homestay',
    image: homestayImages[107].main,
    images: homestayImages[107].gallery,
    address: '45 Bùi Thị Xuân, Phường 6, Đà Lạt',
    description: 'Homestay được thiết kế theo phong cách Provence với vườn oải hương tím ngát, không gian thơ mộng lãng mạn, lý tưởng cho các cặp đôi và nhiếp ảnh.',
    amenities: ['Vườn oải hương', 'WiFi', 'Bếp đầy đủ', 'Máy sưởi', 'Xe đạp', 'Bữa sáng'],
    featured: true,
  },
  {
    id: 108,
    title: 'Treehouse Retreat - Nhà trên cây độc đáo',
    area: 'Xuân Thọ',
    price: 1600000,
    priceUnit: '/đêm',
    bedrooms: 2,
    bathrooms: 1,
    size: 70,
    type: 'homestay',
    image: homestayImages[108].main,
    images: homestayImages[108].gallery,
    address: '78 Rừng Nguyên Sinh, Xuân Thọ, Đà Lạt',
    description: 'Trải nghiệm độc đáo nhất Đà Lạt – ngôi nhà trên cây giữa khu rừng thông nguyên sinh Xuân Thọ, cầu treo, sân thượng cây và vô vàn kỷ niệm khó quên.',
    amenities: ['Cầu treo', 'Sân thượng cây', 'WiFi', 'Bếp mini', 'Lò sưởi', 'Đèn fairy lights'],
    featured: true,
  },
  {
    id: 109,
    title: 'Misty Mountain Chalet - Đà Lạt Highlands',
    area: 'Tà Nung',
    price: 2200000,
    priceUnit: '/đêm',
    bedrooms: 4,
    bathrooms: 3,
    size: 180,
    type: 'homestay',
    image: homestayImages[109].main,
    images: homestayImages[109].gallery,
    address: '3 Đường Ta Nung, Tà Nung, Đà Lạt',
    description: 'Chalet cao cấp trên vùng cao nguyên Tà Nung, kiến trúc đá và gỗ Alpine sang trọng, view núi mây hùng vĩ, bồn tắm ngoài trời ngắm sao.',
    amenities: ['Bồn tắm ngoài trời', 'Lò sưởi', 'WiFi', 'Bếp cao cấp', 'Hầm rượu', 'View núi'],
    featured: false,
  },
];

export const apartmentListings: Property[] = [
  {
    id: 201,
    title: 'Căn hộ cao cấp Đà Lạt Center - Tầng 8',
    area: 'Phường 1 - Trung tâm',
    price: 2800000000,
    priceUnit: '',
    bedrooms: 3,
    bathrooms: 2,
    size: 95,
    type: 'apartment',
    image: apartmentImages[201].main,
    images: apartmentImages[201].gallery,
    address: 'Tòa nhà Đà Lạt Center, 10 Lê Đại Hành, Phường 1',
    description: 'Căn hộ cao cấp tầng 8, view toàn cảnh thành phố Đà Lạt và núi Lang Biang xa xa. Nội thất hoàn thiện cao cấp, sẵn sàng vào ở.',
    amenities: ['Hồ bơi chung', 'Gym', 'Bảo vệ 24/7', 'Hầm xe', 'Thang máy', 'Công viên nội khu'],
    featured: true,
  },
  {
    id: 202,
    title: 'Căn hộ 2PN view Hồ Xuân Hương',
    area: 'Phường 2',
    price: 1950000000,
    priceUnit: '',
    bedrooms: 2,
    bathrooms: 2,
    size: 72,
    type: 'apartment',
    image: apartmentImages[202].main,
    images: apartmentImages[202].gallery,
    address: 'Chung Cư Hồ Xuân Hương, Phường 2, Đà Lạt',
    description: 'Căn hộ 2 phòng ngủ trực diện Hồ Xuân Hương, ban công rộng ngắm cảnh hồ mỗi sáng, vị trí đắc địa bậc nhất Đà Lạt.',
    amenities: ['View hồ', 'Ban công', 'Hầm xe', 'Bảo vệ', 'Thang máy', 'Khu BBQ'],
    featured: true,
  },
  {
    id: 203,
    title: 'Căn hộ Studio hiện đại khu trung tâm',
    area: 'Phường 1 - Trung tâm',
    price: 890000000,
    priceUnit: '',
    bedrooms: 1,
    bathrooms: 1,
    size: 42,
    type: 'apartment',
    image: apartmentImages[203].main,
    images: apartmentImages[203].gallery,
    address: 'Chung cư Mini Center, 45 Nguyễn Văn Trỗi, Phường 1',
    description: 'Studio thông minh trung tâm, thiết kế tối giản hiện đại, tiện ích đầy đủ, thích hợp cho người độc thân và cặp đôi trẻ.',
    amenities: ['Hầm xe', 'Bảo vệ 24/7', 'Thang máy', 'Giặt ủi', 'WiFi chung'],
    featured: false,
  },
  {
    id: 204,
    title: 'Penthouse đỉnh núi tầm nhìn 360°',
    area: 'Phường 4',
    price: 5500000000,
    priceUnit: '',
    bedrooms: 4,
    bathrooms: 3,
    size: 180,
    type: 'apartment',
    image: apartmentImages[204].main,
    images: apartmentImages[204].gallery,
    address: 'Tháp Đà Lạt Sky, Phường 4, Đà Lạt',
    description: 'Penthouse độc quyền với tầm nhìn 360° toàn cảnh núi rừng Đà Lạt, sân thượng riêng, nội thất siêu sang trọng.',
    amenities: ['Sân thượng riêng', 'View 360°', 'Bể sục', 'Hầm xe VIP', 'Concierge', 'Smart home'],
    featured: true,
  },
  {
    id: 205,
    title: 'Căn hộ 3PN khu phức hợp Đà Lạt Green',
    area: 'Phường 7',
    price: 3200000000,
    priceUnit: '',
    bedrooms: 3,
    bathrooms: 2,
    size: 105,
    type: 'apartment',
    image: apartmentImages[205].main,
    images: apartmentImages[205].gallery,
    address: 'Khu phức hợp Đà Lạt Green, Phường 7',
    description: 'Căn hộ 3 phòng ngủ trong khu phức hợp cao cấp với đầy đủ tiện ích: trường học, siêu thị, công viên trong nội khu.',
    amenities: ['Trường học', 'Siêu thị', 'Công viên', 'Hồ bơi', 'Gym', 'Sân tennis'],
    featured: false,
  },
  {
    id: 206,
    title: 'Căn hộ duplex view rừng thông Phường 9',
    area: 'Phường 9',
    price: 2100000000,
    priceUnit: '',
    bedrooms: 3,
    bathrooms: 2,
    size: 115,
    type: 'apartment',
    image: apartmentImages[206].main,
    images: apartmentImages[206].gallery,
    address: 'Chung Cư Forest View, Phường 9, Đà Lạt',
    description: 'Căn duplex 2 tầng view rừng thông tuyệt đẹp, phòng khách thông tầng lấy sáng tự nhiên, thiết kế kiến trúc độc đáo.',
    amenities: ['View rừng thông', 'Duplex', 'Hầm xe', 'Gym', 'Bảo vệ 24/7', 'Sân vườn chung'],
    featured: false,
  },
  {
    id: 207,
    title: 'Căn hộ 2PN khu đô thị mới Phường 10',
    area: 'Phường 10',
    price: 1750000000,
    priceUnit: '',
    bedrooms: 2,
    bathrooms: 2,
    size: 68,
    type: 'apartment',
    image: apartmentImages[207].main,
    images: apartmentImages[207].gallery,
    address: 'Khu Đô Thị Mới Phường 10, Đà Lạt',
    description: 'Căn hộ 2 phòng ngủ trong khu đô thị mới hiện đại Phường 10, nội thất bàn giao cao cấp, dễ dàng di chuyển đến trung tâm thành phố.',
    amenities: ['Hầm xe', 'Bảo vệ 24/7', 'Thang máy', 'Công viên nội khu', 'Ban công', 'WiFi chung'],
    featured: true,
  },
  {
    id: 208,
    title: 'Officetel thông minh khu trung tâm',
    area: 'Phường 1 - Trung tâm',
    price: 1200000000,
    priceUnit: '',
    bedrooms: 1,
    bathrooms: 1,
    size: 50,
    type: 'apartment',
    image: apartmentImages[208].main,
    images: apartmentImages[208].gallery,
    address: '78 Phan Đình Phùng, Phường 1, Đà Lạt',
    description: 'Officetel thông minh kết hợp sinh sống và làm việc trong một không gian linh hoạt, vị trí trung tâm, tiện ích đồng bộ, phù hợp doanh nhân và freelancer.',
    amenities: ['Hầm xe', 'Bảo vệ 24/7', 'Thang máy', 'WiFi tốc độ cao', 'Coworking lounge', 'Smart home'],
    featured: false,
  },
  {
    id: 209,
    title: 'Căn hộ 4PN gia đình view thung lũng Nam Ban',
    area: 'Nam Ban',
    price: 2400000000,
    priceUnit: '',
    bedrooms: 4,
    bathrooms: 3,
    size: 135,
    type: 'apartment',
    image: apartmentImages[209].main,
    images: apartmentImages[209].gallery,
    address: 'Khu Dân Cư Xanh Nam Ban, Nam Ban, Đà Lạt',
    description: 'Căn hộ 4 phòng ngủ rộng rãi tại Nam Ban, view thung lũng và đồn điền cà phê xanh ngát, không khí trong lành, lý tưởng cho gia đình đông thành viên.',
    amenities: ['View thung lũng', 'Hầm xe', 'Bảo vệ', 'Thang máy', 'Công viên', 'Hồ bơi'],
    featured: true,
  },
];

export const formatPrice = (price: number, type: 'rental' | 'homestay' | 'apartment'): string => {
  if (type === 'apartment') {
    if (price >= 1000000000) {
      return `${(price / 1000000000).toFixed(1).replace('.0', '')} tỷ`;
    }
    return `${(price / 1000000).toFixed(0)} triệu`;
  }
  if (price >= 1000000) {
    return `${(price / 1000000).toFixed(0)} triệu`;
  }
  return `${price.toLocaleString('vi-VN')}đ`;
};
